export default __webpack_public_path__ + "media/images/logo/fb-74fa20326fcbbb289923340e6d7a6c34.svg";